export default __webpack_public_path__ + "static/media/96t.e4ea6ecd.jpg";